import { getApiBaseUrl } from "src/config/Endpoints";
import { normalizeApiLang, type ApiLang } from "src/utils/apiLang";
import { buildAuthHeaders, handleJsonResponse } from "./HttpUtils";
import type { KPICardData } from "src/dashboards/webAnalytics/types/Kpi";
import type { TabData } from "src/dashboards/webAnalytics/types/Tabs";

const API_BASE_URL = getApiBaseUrl();

export const ga4DashboardService = {
  fetchDashboardKPI: async (params: {
    start_date: string;
    end_date: string;
    lang: ApiLang;
  }): Promise<{ kpiData: KPICardData[] }> => {
    const searchParams = new URLSearchParams({
      start_date: params.start_date,
      end_date: params.end_date,
      lang: normalizeApiLang(params.lang),
    });
    const response = await fetch(
      `${API_BASE_URL}/ga4/dashboard/kpi?${searchParams.toString()}`,
      {
        method: "GET",
        headers: buildAuthHeaders("api_key"),
      }
    );
    return handleJsonResponse(response);
  },

  fetchTabsKPI: async (params: {
    start_date: string;
    end_date: string;
    metric_selector: string;
    lang: ApiLang;
    limit?: number;
    compare_start_date?: string;
    compare_end_date?: string;
  }): Promise<TabData> => {
    const searchParams = new URLSearchParams({
      start_date: params.start_date,
      end_date: params.end_date,
      metric_selector: params.metric_selector,
      lang: normalizeApiLang(params.lang),
    });
    if (params.limit !== undefined) {
      searchParams.set("limit", String(params.limit));
    }
    if (params.compare_start_date) {
      searchParams.set("compare_start_date", params.compare_start_date);
    }
    if (params.compare_end_date) {
      searchParams.set("compare_end_date", params.compare_end_date);
    }
    const response = await fetch(
      `${API_BASE_URL}/ga4/dashboard/tabs-kpi?${searchParams.toString()}`,
      {
        method: "GET",
        headers: buildAuthHeaders("api_key"),
      }
    );
    const json = await handleJsonResponse(response);
    return json as TabData;
  },
};

